import { CopyText } from '../i18n/Language';
import { useLanguage } from '../i18n/Language';
import ArrowIcon from '../components/ArrowIcon';
import { useEffect } from 'react';
import { studio } from '../data/studio';
import { LeadCaptureBox } from '../components/NewsletterPopup';

export default function Contact() {
  const { t } = useLanguage();
  useEffect(() => { document.title = t("Start a project · Liminality"); }, [t]);
  return (
    <section className="studio-container studio-section contact-page">
      <h1><CopyText source={"Start a"} /><br /><CopyText source={"project."} /></h1>
      <div className="contact-details">
        <p className="team-intro"><CopyText source={"Have a website or app in mind? Tell us what you need and where you are in the process."} /></p>
        <a className="contact-email" href={`mailto:${studio.email}?subject=${encodeURIComponent(t('Let’s talk about a project'))}`}>{studio.email}<ArrowIcon /></a>
        <LeadCaptureBox light source="studio-contact" />
        <div className="contact-note">
          <h2><CopyText source={"Directly with the founders."} /></h2>
          <p><CopyText source={"Your message comes straight to us. We’ll talk through your goals and agree on a clear scope and quote."} /></p>
          <p><CopyText source={"Based in Naples, Italy. Working in English and Italian."} /></p>
        </div>
      </div>
    </section>
  );
}
